<div class="search-menu-wrap">
    <p-autoComplete
        [(ngModel)]="selected"
        [suggestions]="searchMenuResults"
        (completeMethod)="searchMenuItem($event)"
        *ngIf="isMenuSearchActive"
        (onSelect)="selectMenuItem($event)"
        field="name"
        placeholder="{{ 'Search... ' | localize }}"
        [minLength]="1"
        inputStyleClass="form-control menuSearchBarInput"
        styleClass="menuSearchBarContainer"
        class="search-menu"
    ></p-autoComplete>
    <img src="../../../../../assets/common/images/search-icon.svg" class="search-icon" alt="">

    <!-- Voice search mic (shown only when the browser can record AND the server has a Groq key) -->
    <button *ngIf="isMenuSearchActive && voiceSupported && voiceConfigured"
            type="button"
            class="voice-mic-btn"
            [class.is-recording]="recording"
            [class.is-busy]="transcribing"
            [disabled]="transcribing"
            (click)="toggleMic()"
            title="{{ recording ? 'Stop and search' : 'Search by voice' }}">
        <span *ngIf="!recording && !transcribing">&#127908;</span>
        <span *ngIf="recording" class="voice-stop">&#9632;</span>
        <span *ngIf="transcribing" class="voice-spin">&#8987;</span>
    </button>

    <!-- Status line -->
    <div class="voice-status" *ngIf="recording || transcribing || voiceError">
        <span *ngIf="recording" class="voice-listening"><span class="voice-dot"></span> Listening&hellip; tap the mic to stop</span>
        <span *ngIf="transcribing && !recording" class="voice-working">Transcribing&hellip;</span>
        <span *ngIf="voiceError && !recording && !transcribing" class="voice-err">{{ voiceError }}</span>
    </div>

    <!-- Voice results (own dropdown; click to open the menu) -->
    <ul class="voice-results" *ngIf="voiceResults && voiceResults.length > 0">
        <li class="voice-results-head">Did you mean&hellip;</li>
        <li *ngFor="let r of voiceResults" (click)="goTo(r)">
            <span class="voice-go">&#8250;</span> {{ r.name }}
        </li>
    </ul>
</div>
